var map = {
	"./bg.json": 4378,
	"./bs.json": 2086,
	"./cnr.json": 1366,
	"./cs.json": 3571,
	"./da.json": 9914,
	"./de.json": 5894,
	"./el.json": 4524,
	"./en.json": 4174,
	"./es.json": 6725,
	"./et.json": 6004,
	"./fi.json": 6808,
	"./fr.json": 4605,
	"./ga.json": 5593,
	"./hr.json": 6759,
	"./hu.json": 6938,
	"./it.json": 3672,
	"./languageSupported.json": 6351,
	"./lt.json": 5449,
	"./lv.json": 1103,
	"./mk.json": 4165,
	"./nl.json": 4943,
	"./no.json": 7086,
	"./pl.json": 1029,
	"./pt.json": 7741,
	"./ro.json": 2354,
	"./sk.json": 347,
	"./sl.json": 7110,
	"./sq.json": 8141,
	"./sr.json": 8912,
	"./sv.json": 8252,
	"./tr.json": 9755,
	"./zh.json": 9527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3051;